import React from 'react';

export const RadioBinaryHeader = ({posHeading, negHeading}) => (
	<header className="radio-binaries-header">
		<p className="binary-column-heading">{posHeading}</p>
		<p className="binary-column-heading">{negHeading}</p>
	</header>
)


// WEBPACK FOOTER //
// ./src/components/RadioBinary/RadioBinaryHeader.js